var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartupMiniCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 158 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{opacity:0.35;mix-blend-mode:multiply;}.cls-3{fill:#fff;}.cls-4{fill:none;stroke-miterlimit:10;stroke-width:1.57px;stroke:url(#New_Gradient_Swatch_25);}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#linear-gradient-5);}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:url(#linear-gradient-7);}.cls-12{fill:url(#linear-gradient-8);}.cls-13{fill:url(#linear-gradient-9);}.cls-14{fill:url(#linear-gradient-10);}.cls-15{fill:url(#linear-gradient-11);}.cls-16{fill:url(#linear-gradient-12);}.cls-17{fill:url(#linear-gradient-13);}.cls-18{fill:url(#linear-gradient-14);}.cls-19{fill:url(#linear-gradient-15);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_25",
    cx: 78.66,
    cy: 76.49,
    r: 71.66,
    gradientTransform: "translate(77.13 -33.22) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3ac2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#39bfd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2374d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 75.31,
    y1: 39.18,
    x2: 75.31,
    y2: 108.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3ac2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#39bfd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a8fd7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 64.1,
    y1: 39.18,
    x2: 64.1,
    y2: 108.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 86.51,
    y1: 39.18,
    x2: 86.51,
    y2: 108.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 75.33,
    y1: 39.18,
    x2: 75.33,
    y2: 108.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 41.39,
    y1: 39.18,
    x2: 41.39,
    y2: 108.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 30.19,
    y1: 39.18,
    x2: 30.19,
    y2: 108.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 52.6,
    y1: 39.18,
    x2: 52.6,
    y2: 108.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 41.41,
    y1: 39.18,
    x2: 41.41,
    y2: 108.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 109.18,
    y1: 39.18,
    x2: 109.18,
    y2: 108.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 97.97,
    y1: 39.18,
    x2: 97.97,
    y2: 108.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 120.38,
    y1: 39.18,
    x2: 120.38,
    y2: 108.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 109.2,
    y1: 39.18,
    x2: 109.2,
    y2: 108.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 48.77,
    y1: 39.18,
    x2: 48.77,
    y2: 108.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 101.91,
    y1: 39.18,
    x2: 101.91,
    y2: 108.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 75.33,
    y1: 39.18,
    x2: 75.33,
    y2: 108.28,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "COHORT_Admin_Based_Programs_copy_2",
    "data-name": "COHORT Admin Based Programs copy 2"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-2",
    width: 158,
    height: 158,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 78.66,
    cy: 76.49,
    r: 70.87,
    transform: "translate(-31.05 78.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 78.66,
    cy: 76.49,
    r: 70.87,
    transform: "translate(-31.05 78.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.29,56.29c-4.66,0-8.1-4.3-8.74-10.94-.41-4.18.31-7.32,2.13-9.33a8.52,8.52,0,0,1,6.61-2.52c2.92,0,5.18.86,6.7,2.56,1.82,2,2.51,5.16,2.05,9.3h0C83.31,52,79.87,56.29,75.29,56.29Zm0-20.17a5.94,5.94,0,0,0-4.67,1.66c-1.31,1.44-1.8,3.9-1.47,7.31.51,5.21,2.92,8.58,6.14,8.58s5.57-3.37,6.14-8.59h0c.38-3.38-.09-5.82-1.39-7.27A6.09,6.09,0,0,0,75.29,36.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.39,69H58.77l0-6.47a5.45,5.45,0,0,1,3.54-3.78c2.28-.82,6.09-2.38,6.09-2.38l1,2.42s-3.87,1.58-6.19,2.43A2.93,2.93,0,0,0,61.39,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.84,69H89.22V63a2.94,2.94,0,0,0-1.84-1.74c-2.32-.85-6.19-2.43-6.19-2.43l1-2.42S86,58,88.27,58.77a5.47,5.47,0,0,1,3.54,3.78l0,.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 74.02,
    y: 62.76,
    width: 2.62,
    height: 4.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.38,98.6c-4.67,0-8.1-4.29-8.75-10.94-.4-4.18.31-7.32,2.14-9.33a8.5,8.5,0,0,1,6.61-2.51c2.92,0,5.18.86,6.7,2.56,1.81,2,2.5,5.15,2.05,9.3h0C49.39,94.32,46,98.6,41.38,98.6Zm0-20.16a6,6,0,0,0-4.67,1.65c-1.31,1.44-1.8,3.9-1.47,7.32.51,5.21,2.92,8.58,6.14,8.58s5.57-3.38,6.14-8.6h0c.37-3.37-.1-5.81-1.39-7.26A6.07,6.07,0,0,0,41.38,78.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M27.48,111.33H24.86l0-6.47a5.46,5.46,0,0,1,3.54-3.77c2.28-.83,6.09-2.39,6.09-2.39l1,2.43s-3.87,1.58-6.19,2.42a3,3,0,0,0-1.84,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M57.92,111.33H55.3v-6a2.92,2.92,0,0,0-1.84-1.75c-2.32-.84-6.19-2.42-6.19-2.42l1-2.43s3.81,1.56,6.1,2.39a5.48,5.48,0,0,1,3.54,3.77l0,.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 40.1,
    y: 105.07,
    width: 2.62,
    height: 4.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M109.16,98.6c-4.66,0-8.1-4.29-8.74-10.94-.41-4.18.31-7.32,2.13-9.33a8.51,8.51,0,0,1,6.61-2.51c2.92,0,5.18.86,6.7,2.56,1.82,2,2.51,5.15,2,9.3h0C117.18,94.32,113.74,98.6,109.16,98.6Zm0-20.16a5.94,5.94,0,0,0-4.67,1.66c-1.31,1.43-1.8,3.9-1.47,7.31.51,5.21,2.92,8.58,6.14,8.58s5.57-3.38,6.15-8.6h0c.37-3.37-.1-5.81-1.4-7.26C112.91,79,111.31,78.44,109.16,78.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M95.26,111.33H92.64l0-6.47a5.48,5.48,0,0,1,3.54-3.77c2.28-.83,6.09-2.38,6.09-2.39l1,2.43s-3.87,1.58-6.19,2.42a3,3,0,0,0-1.84,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M125.71,111.33h-2.62v-6a2.92,2.92,0,0,0-1.84-1.75c-2.32-.84-6.19-2.42-6.19-2.42l1-2.43s3.81,1.56,6.09,2.39a5.48,5.48,0,0,1,3.54,3.77l0,.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 107.89,
    y: 105.07,
    width: 2.62,
    height: 4.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M42.84,73H40.22V62.85A3.79,3.79,0,0,1,44,59.06H57.32v2.62H44a1.17,1.17,0,0,0-1.17,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M110.46,73h-2.61V62.85a1.18,1.18,0,0,0-1.17-1.17H93.36V59.06h13.32a3.79,3.79,0,0,1,3.78,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M77.32,104.7h-4a1.31,1.31,0,0,1-1.24-.9L71,100.43l-.26-.1-3.18,1.58a1.31,1.31,0,0,1-1.51-.24l-2.82-2.83a1.31,1.31,0,0,1-.25-1.51l1.59-3.18-.11-.25-3.37-1.13a1.31,1.31,0,0,1-.89-1.24v-4a1.32,1.32,0,0,1,.89-1.25l3.37-1.13.11-.25-1.59-3.18a1.31,1.31,0,0,1,.25-1.51L66,77.4a1.31,1.31,0,0,1,1.51-.25l3.18,1.58.26-.1,1.13-3.37a1.31,1.31,0,0,1,1.24-.9h4a1.31,1.31,0,0,1,1.24.9l1.13,3.37.26.1,3.18-1.58a1.31,1.31,0,0,1,1.51.25l2.82,2.82a1.31,1.31,0,0,1,.25,1.51l-1.59,3.18.11.25,3.37,1.13a1.32,1.32,0,0,1,.89,1.25v4a1.31,1.31,0,0,1-.89,1.24L86.23,93.9l-.11.25,1.59,3.18a1.31,1.31,0,0,1-.25,1.51l-2.82,2.83a1.29,1.29,0,0,1-1.51.24L80,100.33l-.26.1-1.13,3.37A1.31,1.31,0,0,1,77.32,104.7Zm-3-2.62h2.11l1-3a1.31,1.31,0,0,1,.74-.79l1.35-.56a1.3,1.3,0,0,1,1.09,0l2.87,1.44,1.49-1.49-1.43-2.87a1.34,1.34,0,0,1,0-1.09L84,92.34a1.33,1.33,0,0,1,.8-.74l3-1v-2.1l-3-1a1.33,1.33,0,0,1-.8-.74l-.56-1.36a1.34,1.34,0,0,1,0-1.09l1.43-2.87-1.49-1.49-2.87,1.44a1.31,1.31,0,0,1-1.08,0l-1.36-.56A1.29,1.29,0,0,1,77.4,80l-1-3H74.27l-1,3a1.29,1.29,0,0,1-.74.79l-1.36.56a1.31,1.31,0,0,1-1.08,0L67.2,79.91,65.71,81.4l1.43,2.87a1.34,1.34,0,0,1,0,1.09l-.56,1.36a1.33,1.33,0,0,1-.8.74l-3,1v2.1l3,1a1.33,1.33,0,0,1,.8.74l.56,1.36a1.34,1.34,0,0,1,0,1.09l-1.43,2.87,1.49,1.49,2.87-1.44a1.3,1.3,0,0,1,1.09,0l1.35.56a1.31,1.31,0,0,1,.74.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M75.33,95.51a6,6,0,1,1,6-6A6,6,0,0,1,75.33,95.51Zm0-9.34a3.36,3.36,0,1,0,3.36,3.36A3.37,3.37,0,0,0,75.33,86.17Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartupMiniCircle);
export default __webpack_public_path__ + "static/media/startupMiniCircle.b6660b25055edf65092175359885517d.svg";
export { ForwardRef as ReactComponent };